import {VERSION} from './version';

export const environment = {
  development: false,
  staging: false,
  production: false,
  systemtest: false,
  VERSION,
  machineKEY:'apiToken123a45r6tjna%etdrha$',
  apiUrl: 'https://environment.squirrel-cde.de/not-implemented/api', //44309
  projectsApi: 'https://environment.squirrel-cde.de/Projects/api/projects', //44353
  projectroles:'https://environment.squirrel-cde.de/Projects/api/roles', //44382
  projectGroupRolePermissions:'https://environment.squirrel-cde.de/Projects/api/projectgrouprolepermissions',
  projectGroupRoles:'https://environment.squirrel-cde.de/Projects/api/projectgrouproles',//44382
  groupRolePermissions:'https://environment.squirrel-cde.de/Projects/api/grouprolespermissions',//44382

  modelsApi: 'https://environment.squirrel-cde.de/not-implemented/api/models', //44396
  revisionsApi: 'https://environment.squirrel-cde.de/not-implemented/api', //44357
  apiUrlRevisions: 'https://environment.squirrel-cde.de/not-implemented/api', //44357  
    
  account: 'https://environment.squirrel-cde.de/Users/api/accounts', //44369
  userProfile:'https://environment.squirrel-cde.de/Users/api/userprofile', //44369
  userPermissions:'https://environment.squirrel-cde.de/Users/api/userpermissions', //44369
  permissions:'https://environment.squirrel-cde.de/Users/api/permissions',
  groupRoles:'https://environment.squirrel-cde.de/Users/api/grouproles',
  platformGroupRoles: 'https://environment.squirrel-cde.de/Users/api/platformgrouproles',
  identityApi:'https://environment.squirrel-cde.de/Users/api/identity', //44369
  identityAccount: 'https://environment.squirrel-cde.de/IdentitySTS/account', //44310
  identityAdmin: 'https://environment.squirrel-cde.de/IdentitySTS', //44303
  genericDocuments:'https://environment.squirrel-cde.de/Documents/api/genericdocuments', //44342
  documents:'https://environment.squirrel-cde.de/Documents/api/documents', //44342
  valueConfPage:'https://environment.squirrel-cde.de/Documents/api/valueconfpage', //44342
  valueConfAttribute:'https://environment.squirrel-cde.de/Documents/api/valueconfattribute', //44342
  attributeValue:'https://environment.squirrel-cde.de/Documents/api/attributevalue', //44342
  statusColor:'https://environment.squirrel-cde.de/Documents/api/statuscolor', //44342

  databaseMigrations:'https://environment.squirrel-cde.de/DbMigrations/api/databaseupdates',//44368

  tenants:'https://environment.squirrel-cde.de/Tenants/api/tenants', //44379
  tenantProjects:'https://environment.squirrel-cde.de/Tenants/api/projects', //44379
  tenantUsers:'https://environment.squirrel-cde.de/Tenants/api/users', //44379
  tenantProjectGroupRoles:'https://environment.squirrel-cde.de/Tenants/api/projectgrouproles', //44379
  tenantGroupRolePermissions:'https://environment.squirrel-cde.de/Tenants/api/grouprolespermissions', //44379
  tenantProjectRoles:'https://environment.squirrel-cde.de/Tenants/api/projectroles', //44379
  tenantProjectGroupRolePermissions:'https://environment.squirrel-cde.de/Tenants/api/projectgrouprolepermissions', //44379
  tenantplatformGroupRoles:'https://environment.squirrel-cde.de/Tenants/api/platformgrouproles', //44379
  tenantpermissions:'https://environment.squirrel-cde.de/Tenants/api/permissions', //44379
  tenantgrouproles:'https://environment.squirrel-cde.de/Tenants/api/tenantgrouproles', //44379
  tenantapplicationtokens:'https://environment.squirrel-cde.de/Tenants/api/tokenservice', //44379
  tenantaudit:'https://environment.squirrel-cde.de/Tenants/api/auditservice', //44379
  tenantfiles: 'https://environment.squirrel-cde.de/Tenants/api/file', //44379
  
  projecturl:'https://project.squirrel-cde.de',


  
  // legacySquirrelCommonApi:'https://sq3devprojects.albert-ing.com/squirrelAPI/CommonApi',
  // legacySquirrelV3:'https://sq3devprojects.albert-ing.com/squirrelAPI/SquirrelV3',

  //------- Dev-Server --------------------------------------------------------------------------------------

  sq3devLegacySquirrelCommonApi:'https://sq3devprojects.albert-ing.com/squirrelAPI/CommonApi',
  sq3devLegacySquirrelV3:'https://sq3devprojects.albert-ing.com/squirrelAPI/SquirrelV3',

  //--------------------------------------------------------------------------------------------------------

   //-------- Localhost ---------------------------------------------------------------------------------------

   localLegacySquirrelCommonApi:'https://sq3devprojects.albert-ing.com/squirrelAPI/CommonApi',
   localLegacySquirrelV3:'https://sq3devprojects.albert-ing.com/squirrelAPI/SquirrelV3',
 
   // --------------------------------------------------------------------------------------------------------- 
   
 
   //------- Dev-Server --------------------------------------------------------------------------------------
 
   devLegacySquirrelCommonApi:'https://squirrel3developmentprojects.albert-ing.com/squirrelAPI/CommonApi',
   devLegacySquirrelV3:'https://squirrel3developmentprojects.albert-ing.com/squirrelAPI/SquirrelV3',
 
   //--------------------------------------------------------------------------------------------------------
 
   // ------- TestServer1 ----------------------------------------------------------------------------------------
 
   squirreltest1LegacySquirrelCommonApi: 'https://squirreltest1.albert-ing.com/squirrelAPI/CommonApi',
   squirreltest1LegacySquirrelV3: 'https://squirreltest1.albert-ing.com/squirrelAPI/SquirrelV3',
   squirreltest2LegacySquirrelV3: 'https://squirreltest2.albert-ing.com/squirrelAPI/SquirrelV3',
 
   //------------------------------------------------------------------------------------------------------------
 

  openIdConnectSettings: {
    // Kleinschreibung erforderlich: IdentityServer4 liefert den Issuer lowercased
    // (LowerCaseIssuerUri), und angular-auth-oidc-client v21 vergleicht strikt.
    authority: 'https://environment.squirrel-cde.de/identitysts',
    client_id: 'squirrelclient',
    response_type: 'code',
    // Muss exakt der im IdentityServer registrierten RedirectUri entsprechen.
    // Der TrailingSlashUrlSerializer in der App matcht beide Varianten.
    redirect_uri: 'https://platform.squirrel-cde.de/signin-callback/',
    scope: 'openid profile roles projectsmicroservice usersmicroservice documentsmicroservice squirrelfbdbmigrations tenantsmicroservice',
    // post_logout_redirect_uri: 'https://platform.squirrel-cde.de/signin-callback',
    post_logout_redirect_uri: 'https://platform.squirrel-cde.de/',
    automaticSilentRenew: true,
    silent_redirect_uri: 'https://platform.squirrel-cde.de/redirect-silentrenew'
  }
};